import calculation from '@/common/js/calculation';
export default {
  computed: {
    tableColumnsList1() {
      return [
        {
          field: '',
          title: '货款(支付)',
          align: 'center',
          children: [
            {
              field: 'supplierName',
              title: '供货单位',
              align: 'center',
              width: 120,
            },
            {
              field: '',
              title: '发运金额',
              align: 'center',
              children: [
                {
                  field: 'settlementNo',
                  title: '批次',
                  align: 'center',
                  width: 120,
                },
                {
                  field: 'periodRange',
                  title: '时间段',
                  align: 'center',
                  width: 120,
                },
                {
                  field: 'settlementDate',
                  title: '结算时间',
                  align: 'center',
                  width: 120,
                },
                {
                  field: 'preSettlementQuantity',
                  title: '预结算数量(吨）',
                  align: 'center',
                  width: 120,
                },
                {
                  field: 'preSettlementAmount',
                  title: '预结算总金额',
                  align: 'center',
                  width: 120,
                  formatter: this.formatterNum,
                },
                {
                  field: 'finalSettlementAmount',
                  title: '结算(对账)',
                  align: 'center',
                  width: 120,
                  formatter: this.formatterNum,
                },
                {
                  field: 'finalSettlementQuantity',
                  title: '数量(吨)',
                  align: 'center',
                  width: 120,
                },
                {
                  field: 'rate',
                  title: '比例',
                  align: 'center',
                  width: 120,
                },
                {
                  field: 'rateAmount',
                  title: '对应比例货物金额',
                  align: 'center',
                  width: 120,
                  formatter: this.formatterNum,
                },
              ],
            },
            {
              field: '',
              title: '已付金额',
              align: 'center',
              children: [
                {
                  field: 'paymentDate',
                  title: '付款日期',
                  align: 'center',
                  width: 120,
                },
                {
                  field: 'paymentAmount',
                  title: '金额',
                  align: 'center',
                  width: 120,
                  formatter: this.formatterNum,
                },
              ],
            },
            {
              field: 'unPaymentAmount',
              title: '应付未付金额',
              align: 'center',
              width: 120,
              formatter: this.formatterNum,
            },
          ],
        },
        {
          field: 'productDesc',
          title: '发票(收取)',
          align: 'center',
          children: [
            {
              field: '',
              title: '应收票金额',
              align: 'center',
              children: [
                {
                  field: 'invoiceAmount',
                  title: '应收票金额',
                  width: 120,
                  align: 'center',
                  formatter: this.formatterNum,
                },
                {
                  field: '',
                  title: '已收增值税票',
                  align: 'center',
                  children: [
                    {
                      field: 'invoiceDate',
                      title: '时间',
                      width: 120,
                      align: 'center',
                    },
                    {
                      field: 'invoiceQuantity',
                      title: '数量(吨)',
                      width: 120,
                      align: 'center',
                    },
                    {
                      field: 'invoicedAmount',
                      title: '金额',
                      width: 120,
                      align: 'center',
                      formatter: this.formatterNum,
                    },
                  ],
                },
                {
                  field: '',
                  title: '未收增值税票',
                  align: 'center',
                  children: [
                    {
                      field: 'invoiceQuantity1',
                      title: '数量(吨)',
                      width: 120,
                      align: 'center',
                    },
                    {
                      field: 'invoiceAmount1',
                      title: '金额',
                      width: 120,
                      align: 'center',
                      formatter: this.formatterNum,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          field: 'invoiceAmount2',
          title: '账面余额',
          width: 120,
          align: 'center',
          formatter: this.formatterNum,
        },
      ];
    },
    tableColumnsList2() {
      return [
        {
          field: '',
          title: '货款(收取)',
          align: 'center',
          children: [
            {
              field: 'customerName',
              title: '销售单位',
              align: 'center',
              width: 120,
            },
            {
              field: '',
              title: '发运金额',
              align: 'center',
              width: 120,
              children: [
                {
                  field: 'settlementNo',
                  title: '批次',
                  align: 'center',
                  width: 120,
                },
                // {
                //   field: 'periodRange',
                //   title: '时间段',
                //   align: 'center',
                //   width: 120,
                // },
                {
                  field: 'settlementQuantity',
                  title: '数量(吨)',
                  align: 'center',
                  width: 120,
                },
                {
                  field: 'settlementAmount',
                  title: '金额',
                  align: 'center',
                  width: 120,
                  formatter: this.formatterNum,
                },
              ],
            },
            {
              field: '',
              title: '已收金额',
              align: 'center',
              width: 120,
              children: [
                {
                  field: 'receiveDate',
                  title: '收款日期',
                  align: 'center',
                  width: 120,
                },
                {
                  field: 'receiveAmount',
                  title: '金额',
                  align: 'center',
                  width: 120,
                  formatter: this.formatterNum,
                },
              ],
            },
            {
              field: 'receiveAmount1',
              title: '应收未收金额',
              align: 'center',
              width: 120,
              formatter: this.formatterNum,
            },
          ],
        },
        {
          field: '',
          title: '发票(开出)',
          align: 'center',
          width: 120,
          children: [
            {
              field: 'settlementAmount1',
              title: '应开票金额',
              align: 'center',
              width: 120,
              formatter: this.formatterNum,
            },
            {
              field: '',
              title: '已开增值税票',
              align: 'center',
              width: 120,
              children: [
                {
                  field: 'invoiceDate',
                  title: '时间',
                  align: 'center',
                  width: 120,
                },
                {
                  field: 'invoicedAmount',
                  title: '金额',
                  align: 'center',
                  width: 120,
                  formatter: this.formatterNum,
                },
                {
                  field: 'invoiceQuantity',
                  title: '数量(吨)',
                  align: 'center',
                  width: 120,
                  formatter: this.formatterQuantity,
                },
              ],
            },
            {
              field: '',
              title: '未开票金额',
              align: 'center',
              width: 120,
              children: [
                {
                  field: 'invoiceQuantity1',
                  title: '数量(吨)',
                  align: 'center',
                  width: 120,
                },
                {
                  field: 'invoiceAmount1',
                  title: '金额',
                  align: 'center',
                  width: 120,
                  formatter: this.formatterNum,
                },
              ],
            },
          ],
        },
        {
          field: 'invoiceAmount2',
          title: '账面余额',
          align: 'center',
          width: 120,
          formatter: this.formatterNum,
        },
      ];
    },
  },
  methods: {
    formatterNum({ cellValue }) {
      if (!cellValue && isNaN(cellValue)) return null;
      return this.$utils.commafy(this.$utils.toNumber(cellValue), { digits: 2 });
    },
    formatterQuantity({ data, rowIndex }) {
      if (rowIndex === 0) {
        const total1 = data.reduce(
          (pre, cur) => calculation.accAdd(pre, cur?.invoicedAmount ? +cur?.invoicedAmount : 0),
          0
        );
        const total2 = data.reduce(
          (pre, cur) => calculation.accAdd(pre, cur?.settlementAmount ? +cur?.settlementAmount : 0),
          0
        );
        const total3 = data.reduce(
          (pre, cur) =>
            calculation.accAdd(pre, cur?.settlementQuantity ? +cur?.settlementQuantity : 0),
          0
        );
        const rate = this.$cal.calCommon(total1, total2, '/', 'quantity');
        return this.$cal.calCommon(rate, total3, '*', 'quantity');
      } else {
        return '';
      }
    },
    footerMethod1({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          console.log(column, data);
          if (columnIndex === 0) {
            return '合计';
          }
          /**
           * 预结算数量(吨） = 所有行的 preSettlementQuantity 之和
              预结算总金额  = 所有的 preSettlementAmount 之和
              已付金额.金额 = 所有行的  paymentAmount
              应付未付金额 = 预付总金额 (预结算总金额  = 所有的 preSettlementAmount 之和)- (已付金额.金额 = 所有行的  paymentAmount)

              应收票金额 = 所以行中的 invoiceAmount 之和

              已收增值税票.数量 = invoiceQuantity 之和
              已收增值税票.金额 = invoiceAmount 之和
              未收增值税票.数量 = 预结算数量(吨） - 已收增值税票.数量
              未收增值税票.金额 = 应收票金额 - 已收增值税票.金额
              账面余额 = 已收增值税票.金额 - 已付金额.金额
           */
          if (column.property == 'preSettlementQuantity') {
            return data.reduce(
              (pre, cur) =>
                calculation.accAdd(
                  pre,
                  cur?.preSettlementQuantity ? +cur?.preSettlementQuantity : 0
                ),
              0
            );
          }
          if (column.property == 'preSettlementAmount') {
            const total = data.reduce(
              (pre, cur) =>
                calculation.accAdd(pre, cur?.preSettlementAmount ? +cur?.preSettlementAmount : 0),
              0
            );
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'finalSettlementAmount') {
            const total = data.reduce(
              (pre, cur) =>
                calculation.accAdd(
                  pre,
                  cur?.finalSettlementAmount ? +cur?.finalSettlementAmount : 0
                ),
              0
            );
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'finalSettlementQuantity') {
            return data.reduce(
              (pre, cur) =>
                calculation.accAdd(
                  pre,
                  cur?.finalSettlementQuantity ? +cur?.finalSettlementQuantity : 0
                ),
              0
            );
          }
          if (column.property == 'rateAmount') {
            const total = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.rateAmount ? +cur?.rateAmount : 0),
              0
            );
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'paymentAmount') {
            const total = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.paymentAmount ? +cur?.paymentAmount : 0),
              0
            );
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }

          if (column.property == 'unPaymentAmount') {
            const total1 = data.reduce(
              (pre, cur) =>
                calculation.accAdd(
                  pre,
                  cur?.finalSettlementAmount ? +cur?.finalSettlementAmount : 0
                ),
              0
            );
            const total2 = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.paymentAmount ? +cur?.paymentAmount : 0),
              0
            );
            const total = calculation.accSub(total1, total2);
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'invoicedAmount') {
            const total = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.invoicedAmount ? +cur?.invoicedAmount : 0),
              0
            );
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'invoiceAmount') {
            const total = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.invoiceAmount ? +cur?.invoiceAmount : 0),
              0
            );
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'invoiceQuantity') {
            return data.reduce(
              (pre, cur) =>
                calculation.accAdd(pre, cur?.invoiceQuantity ? +cur?.invoiceQuantity : 0),
              0
            );
          }
          if (column.property == 'invoiceQuantity1') {
            const total1 = data.reduce(
              (pre, cur) =>
                calculation.accAdd(
                  pre,
                  cur?.finalSettlementQuantity ? +cur?.finalSettlementQuantity : 0
                ),
              0
            );
            const total2 = data.reduce(
              (pre, cur) =>
                calculation.accAdd(pre, cur?.invoiceQuantity ? +cur?.invoiceQuantity : 0),
              0
            );
            let total = String(calculation.accSub(total1, total2));
            let totalPrecison = '';
            if (total.toLowerCase().includes('e')) {
              totalPrecison = total?.substring(total.toLowerCase().indexOf('e') + 2);
              return this.$utils.commafy(this.$utils.toNumber(total), { digits: totalPrecison });
            } else {
              return calculation.accSub(total1, total2);
            }
          }
          if (column.property == 'invoiceAmount1') {
            const total1 = data.reduce(
              (pre, cur) =>
                calculation.accAdd(
                  pre,
                  cur?.finalSettlementAmount ? +cur?.finalSettlementAmount : 0
                ),
              0
            );
            const total2 = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.invoicedAmount ? +cur?.invoicedAmount : 0),
              0
            );
            const total = calculation.accSub(total1, total2);
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'invoiceAmount2') {
            const total1 = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.paymentAmount ? +cur?.paymentAmount : 0),
              0
            );
            const total2 = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.invoicedAmount ? +cur?.invoicedAmount : 0),
              0
            );
            const total = calculation.accSub(total2, total1);
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          // if (['priceWithTax'].includes(column.property)) {
          //   this.priceWithTaxToal = data
          //     .map((i) => i['priceWithTax'])
          //     .reduce((acc, cur) => {
          //       const num = this.$cal.calCommon(acc, cur, '+', 'price');
          //       return num;
          //     }, 0);
          //   return this.$baseRequest.formatTableColumn(
          //     this.priceWithTaxToal,
          //     this.$globalVar.pPoint
          //   );
          // }

          return null;
        }),
      ];
    },
    footerMethod2({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          console.log(column, data);
          if (columnIndex === 0) {
            return '合计';
          }

          if (column.property == 'settlementQuantity') {
            return data.reduce(
              (pre, cur) =>
                calculation.accAdd(pre, cur?.settlementQuantity ? +cur?.settlementQuantity : 0),
              0
            );
          }
          if (column.property == 'settlementAmount') {
            const total = data.reduce(
              (pre, cur) =>
                calculation.accAdd(pre, cur?.settlementAmount ? +cur?.settlementAmount : 0),
              0
            );
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'receiveAmount') {
            const total = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.receiveAmount ? +cur?.receiveAmount : 0),
              0
            );
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'preSettlementQuantity') {
            return data.reduce(
              (pre, cur) =>
                calculation.accAdd(
                  pre,
                  cur?.preSettlementQuantity ? +cur?.preSettlementQuantity : 0
                ),
              0
            );
          }
          if (column.property == 'preSettlementAmount') {
            const total = data.reduce(
              (pre, cur) =>
                calculation.accAdd(pre, cur?.preSettlementAmount ? +cur?.preSettlementAmount : 0),
              0
            );
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'paymentAmount') {
            const total = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.paymentAmount ? +cur?.paymentAmount : 0),
              0
            );
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }

          if (column.property == 'unPaymentAmount') {
            const total1 = data.reduce(
              (pre, cur) =>
                calculation.accAdd(pre, cur?.preSettlementAmount ? +cur?.preSettlementAmount : 0),
              0
            );
            const total2 = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.paymentAmount ? +cur?.paymentAmount : 0),
              0
            );
            const total = calculation.accSub(total1, total2);
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'invoiceAmount') {
            const total = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.invoiceAmount ? +cur?.invoiceAmount : 0),
              0
            );
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'invoiceQuantity') {
            //（已开票金额/总金额）* 总吨数
            const total1 = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.invoicedAmount ? +cur?.invoicedAmount : 0),
              0
            );
            const total2 = data.reduce(
              (pre, cur) =>
                calculation.accAdd(pre, cur?.settlementAmount ? +cur?.settlementAmount : 0),
              0
            );
            const total3 = data.reduce(
              (pre, cur) =>
                calculation.accAdd(pre, cur?.settlementQuantity ? +cur?.settlementQuantity : 0),
              0
            );
            const rate = this.$cal.calCommon(total1, total2, '/', 'quantity');
            return this.$cal.calCommon(rate, total3, '*', 'quantity');
          }
          if (column.property == 'invoicedAmount') {
            const total = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.invoicedAmount ? +cur?.invoicedAmount : 0),
              0
            );
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'invoiceQuantity1') {
            // 以下为取已开票总吨数 （已开票金额/总金额）* 总吨数
            const total1 = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.invoicedAmount ? +cur?.invoicedAmount : 0),
              0
            );
            const total2 = data.reduce(
              (pre, cur) =>
                calculation.accAdd(pre, cur?.settlementAmount ? +cur?.settlementAmount : 0),
              0
            );
            const total3 = data.reduce(
              (pre, cur) =>
                calculation.accAdd(pre, cur?.settlementQuantity ? +cur?.settlementQuantity : 0),
              0
            );
            const rate = this.$cal.calCommon(total1, total2, '/', 'quantity');
            const quantity = this.$cal.calCommon(rate, total3, '*', 'quantity');
            return calculation.accSub(total3, quantity);
          }
          if (column.property == 'invoiceAmount1') {
            const total1 = data.reduce(
              (pre, cur) =>
                calculation.accAdd(pre, cur?.settlementAmount ? +cur?.settlementAmount : 0),
              0
            );
            const total2 = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.invoicedAmount ? +cur?.invoicedAmount : 0),
              0
            );
            const total = calculation.accSub(total1, total2);
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'invoiceAmount2') {
            const total1 = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.invoicedAmount ? +cur?.invoicedAmount : 0),
              0
            );
            const total2 = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.receiveAmount ? +cur?.receiveAmount : 0),
              0
            );
            const total = calculation.accSub(total1, total2);
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'receiveAmount1') {
            const total1 = data.reduce(
              (pre, cur) =>
                calculation.accAdd(pre, cur?.settlementAmount ? +cur?.settlementAmount : 0),
              0
            );
            const total2 = data.reduce(
              (pre, cur) => calculation.accAdd(pre, cur?.receiveAmount ? +cur?.receiveAmount : 0),
              0
            );
            const total = calculation.accSub(total1, total2);
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }
          if (column.property == 'settlementAmount1') {
            const total = data.reduce(
              (pre, cur) =>
                calculation.accAdd(pre, cur?.settlementAmount ? +cur?.settlementAmount : 0),
              0
            );
            return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
          }

          return null;
        }),
      ];
    },
  },
};
